<template>
    <div>
        <div class="detail-header-container">
            <div />
            <div class="round-btn" @click="closeDetailPage()"><i class="fas fa-times" /></div>
        </div>

        <div class="empty-sidebar-container">
            <p>Select an item or record to view its details</p>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        },
    },
};
</script>

<style lang="css" scoped>
.empty-sidebar-container {
    height: 300px;
    justify-content: center;
    align-items: center;
    display: flex;
}
.empty-sidebar-container p{
    color: var(--description-grey)
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/EmptySidebarDetail.vue